import { format, utcToZonedTime } from "date-fns-tz";

const Transport = ({ transport, styles }) => {
  const formattedOutbound = transport.outbound.date && format(
    utcToZonedTime(new Date(transport.outbound.date), "UTC"),
    "dd MMM yyyy",
    { timeZone: "UTC" }
  );

  const formattedInbound = transport.inbound.date && format(
    utcToZonedTime(new Date(transport.inbound.date), "UTC"),
    "dd MMM yyyy",
    { timeZone: "UTC" }
  );

  return transport.carrier && (
    <div className={styles.cartItem}>
      <h3>Transport</h3>
      <div className={styles.cro1381HotelMeta}>
        <div className={styles.transportOutbound} id="outbound">
          <span className={styles.transportDirection}>Outbound: </span>
          <span className={styles.transportCarrier}>{transport.carrier}</span>
          {", "}
          <span className={styles.transportDepart}>{formattedOutbound}</span>
          {", "}
          <span className={styles.transportDepart}>
            {transport.outbound.time}
          </span>
        </div>
        <div className={styles.transportInbound} id="inbound">
          <span className={styles.transportDirection}>Inbound: </span>
          <span className={styles.transportCarrier}>{transport.carrier}</span>
          {", "}
          <span className={styles.transportDepart}>{formattedInbound}</span>
          {", "}
          <span className={styles.transportDepart}>
            {transport.inbound.time}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Transport;
